module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.currentTheme.name
  }, [_c('div', {
    staticClass: "game-config"
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.init
    }
  }, [_vm._v("重新开始")])]), _vm._v(" "), _c('table', {
    staticClass: "game",
    on: {
      "click": _vm.handleClick
    }
  }, _vm._l((_vm.cellData), function(cols, row) {
    return _c('tr', {
      key: row
    }, _vm._l((cols), function(cell, col) {
      return _c('cell', {
        key: col,
        attrs: {
          "isSelected": cell.isSelected,
          "isLine": cell.isLine,
          "lineClass": cell.lineClass,
          "isBlank": cell.isBlank,
          "className": cell.className
        }
      })
    }))
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.11.3.3@vue-loader/lib/template-compiler?{"id":"data-v-663bcf55"}!./~/.11.3.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/game.vue
// module id = 49
// module chunks = 1